import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=7a3f1b66"
import script from "./Regions.vue?vue&type=script&lang=js"
export * from "./Regions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports